var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8505_4508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0224609 10.0417L27.7742 0.153809L56.2733 9.86587L51.6589 46.5828L27.7742 59.8106L4.26327 46.7586L0.0224609 10.0417Z",
    fill: "#E23237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2735 9.86587L27.7744 0.153809V59.8106L51.659 46.6048L56.2735 9.86587Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.818 7.11914L10.5254 45.5939L16.9853 45.4841L20.4572 36.8046H35.97L39.7714 45.5939L45.9457 45.7038L27.818 7.11914ZM27.8621 19.4461L33.7068 31.6629H22.7202L27.8621 19.4461Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8505_4508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.472,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.0da058944f58d06159fd33a3139926ff.svg";
export { ForwardRef as ReactComponent };